export const normalizeRepLanguage = value => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9€]+/g, ' ')
  .trim();

export const REP_VOCABULARY = {
  highlight: ['highlight', 'highlights', 'clip', 'clips', 'taglio', 'tagli', 'ritaglio', 'ritagli', 'spezzone', 'spezzoni', 'estratto', 'estratti', 'azione ritagliata', 'azioni ritagliate'],
  analysis: ['analisi', 'statistica partita', 'statistiche partita', 'pb vision', 'pbvision', 'analizzare partita'],
  video: ['video', 'filmato', 'filmati', 'registrazione', 'registrazioni', 'ripresa', 'riprese', 'partita registrata', 'partite registrate'],
  folder: ['cartella', 'cartelle', 'raccolta', 'raccolte', 'archivio', 'archivi', 'organizzare contenuti'],
  booking: ['prenotazione', 'prenotazioni', 'riserva campo', 'riservare campo', 'prenotare', 'prenota', 'booking'],
  field: ['campo', 'campi', 'campo sportivo', 'campi sportivi', 'impianto', 'impianti', 'struttura sportiva', 'strutture sportive'],
  participant: ['partecipante', 'partecipanti', 'giocatore replayer', 'giocatori replayer', 'player invitato', 'player invitati'],
  guest: ['ospite', 'ospiti', 'invitato pagato da me', 'invitati pagati da me', 'persona senza account', 'persone senza account'],
  wallet: ['credito', 'wallet', 'saldo replayer', 'portafoglio'],
  topup: ['ricarica', 'ricariche', 'ricaricare', 'aggiungere credito', 'versare credito'],
  replayertv: ['replayertv', 'replayer tv', 'canale tv', 'canale del circolo'],
  partner: ['partner', 'partners', 'centro sportivo', 'centri sportivi', 'circolo', 'circoli', 'societa sportiva', 'societa sportive'],
  planning: ['pianificazione', 'pianificazioni', 'pianificare', 'creare slot', 'programmare disponibilita', 'programmare campo'],
  share: ['condividere', 'condivisione', 'inviare link', 'mandare collegamento', 'link pubblico']
};

const containsTerm = (normalized, term) => {
  const normalizedTerm = normalizeRepLanguage(term);
  return ` ${normalized} `.includes(` ${normalizedTerm} `);
};

export const getRepConcepts = value => {
  const normalized = normalizeRepLanguage(value);
  const concepts = Object.keys(REP_VOCABULARY).filter(concept => (
    REP_VOCABULARY[concept].some(term => containsTerm(normalized, term))
  ));

  // Nel contesto esplicito di un’Analisi, “taglio” e “spezzone” indicano
  // la preparazione del file e non la creazione di un Highlight autonomo.
  if (concepts.includes('analysis') && !containsTerm(normalized, 'highlight')) {
    return concepts.filter(concept => concept !== 'highlight');
  }
  return concepts;
};

export const hasRepConcept = (value, concept) => getRepConcepts(value).includes(concept);
